module.exports = __webpack_public_path__ + "img/verified-badge-mobile-bg.svg";